import React from 'react';
import { motion } from 'framer-motion';

const variants = {
  primary: {
    background: `
      linear-gradient(135deg, rgba(255,255,255,0.12) 0%, rgba(255,255,255,0.06) 50%, rgba(255,255,255,0.12) 100%),
      radial-gradient(circle at 30% 30%, rgba(255,255,255,0.18) 0%, transparent 50%)
    `,
    textColor: 'rgba(255,255,255,0.95)',
    shadow: '0 4px 24px rgba(0,0,0,0.18)'
  },
  secondary: {
    background: `
      linear-gradient(135deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 50%, rgba(255,255,255,0.08) 100%),
      radial-gradient(circle at 70% 70%, rgba(255,255,255,0.12) 0%, transparent 50%)
    `,
    textColor: 'rgba(255,255,255,0.85)',
    shadow: '0 2px 12px rgba(0,0,0,0.12)'
  },
  dark: {
    background: `
      linear-gradient(135deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.3) 100%),
      radial-gradient(circle at 30% 30%, rgba(255,255,255,0.05) 0%, transparent 50%)
    `,
    textColor: 'rgba(255,255,255,0.9)',
    shadow: '0 4px 24px rgba(0,0,0,0.25)'
  }
};

const sizes = {
  small: {
    fontSize: '1.5rem',
    padding: '8px 20px',
    borderRadius: '10px'
  },
  medium: {
    fontSize: '2.2rem',
    padding: '14px 32px',
    borderRadius: '14px'
  },
  large: {
    fontSize: '3rem',
    padding: '20px 48px',
    borderRadius: '18px'
  }
};

const Title = ({
  children,
  variant = 'primary',
  size = 'medium',
  as = 'h1',
  style = {},
  className = '',
  ...props
}) => {
  const Tag = as;
  const currentVariant = variants[variant] || variants.primary;
  const currentSize = sizes[size] || sizes.medium;

  return (
    <motion.div
      initial={{ opacity: 0, y: -30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, ease: [0.4, 0, 0.2, 1] }}
      className={`liquid-glass-title ${className}`}
      style={{
        display: 'inline-block',
        background: currentVariant.background,
        color: currentVariant.textColor,
        boxShadow: currentVariant.shadow,
        padding: currentSize.padding,
        borderRadius: currentSize.borderRadius,
        backdropFilter: 'blur(18px)',
        WebkitBackdropFilter: 'blur(18px)',
        fontWeight: 700,
        fontSize: currentSize.fontSize,
        textAlign: 'center',
        letterSpacing: '0.01em',
        lineHeight: 1.1,
        margin: 0,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        ...style
      }}
      {...props}
    >
      <Tag style={{
        background: 'linear-gradient(45deg, #fff, #f0f0f0)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        margin: 0,
        fontSize: 'inherit',
        fontWeight: 'inherit',
        lineHeight: 'inherit',
        letterSpacing: 'inherit',
        textShadow: '0 4px 8px rgba(0,0,0,0.18)',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
      }}>{children}</Tag>
    </motion.div>
  );
};

export default Title; 